import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR, renderStraightArrow, renderStraightPulse } from "./renderingUtils";

export const pipeComponent: FlowComponentDefinition = {
  type: "pipe",
  title: "pipe",
  category: "Pipes & Fittings",
  visualKind: "pipe",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "left", to: "right" },
  ports: ["left", "right"],
  incomingDirections: ["left"],
  outgoingDirections: ["right"],
  defaults: { length: "1000", diameter: "100", roughness: "0.1" },
  fields: [
    { key: "length", label: "Length" },
    { key: "diameter", label: "Diameter" },
    { key: "roughness", label: "Roughness" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: (context) =>
    context.isHorizontal ? (
      <>
        <rect
          x="0"
          y="40"
          width="100"
          height="20"
          rx="4"
          fill={context.componentColor}
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
        />
        <line
          x1="14"
          y1="50"
          x2="86"
          y2="50"
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        {renderStraightArrow(context)}
      </>
    ) : (
      <>
        <rect
          x="40"
          y="0"
          width="20"
          height="100"
          rx="4"
          fill={context.componentColor}
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
        />
        <line
          x1="50"
          y1="14"
          x2="50"
          y2="86"
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        {renderStraightArrow(context)}
      </>
    ),
  renderAnimatedFlow: (context) => renderStraightPulse(context),
};
